// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__KIbON","content":"Footer_content__DF3gs","githubButtonContainer":"Footer_githubButtonContainer__2fGSD","githubButton":"Footer_githubButton__1qNsH"};